export const permissionsByRole = {
  Owner: ["projects", "builds", "drivers", "news", "settings"],
  Driver: ["builds", "news", "settings"],
};

export const projectAccessPermissionForDriverRole = [
  "projects",
  ...permissionsByRole["Driver"],
];
